import React, { Component } from 'react';
import '../../App.css';
import '../../styles/app-demo.css';
import AppFooter from './app-footer';

class AppMenu extends Component {

  constructor(props){
    super(props)
    this.state = {
      footerUnderline: 'menu'
    }
  }

  render() {

    return (
      <section>
        <div className="fintwist-interactive-mobile">
        <section className="mobile-app-wrapper">
          <div className="orange-header">
            <h2>Menu</h2>
          </div>
          <div className="mobile-app-dashboard">
            <div className="name-header-wrapper">
              <p>{this.props.userName}</p>
              <i onClick={() => this.props.toggleNewRoute('login', 'logout')} className="fa fa-sign-out"></i>
            </div>
            <ul id="menu-list">
              <li onClick={() => this.props.toggleNewRoute('bill pay')}>
                <p>Bill Pay</p>
              </li>
              <li onClick={() => this.props.toggleNewRoute('card management')}>
                <p>Card Management</p>
              </li>
              <li onClick={() => this.props.toggleNewRoute('atm locator', 'menu')}>
                <p>ATM Locator</p>
              </li>
            </ul>
          </div>
        </section>
        <AppFooter {...this.state} toggleNewRoute={this.props.toggleNewRoute} />
        </div>
      </section>
    );
  }
}

export default AppMenu;
